module.exports = __webpack_public_path__ + "img/minimized.031c3825.svg";